/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getPublicArticle} from '../api'

 export const useQueryGetPublicArticle = createReactQueryHook('getPublicArticle', getPublicArticle)
